<template>
  <v-list dense>
    <v-list-item
      v-for="option in menu"
      :key="option.internalValue"
      :disabled="isLoading[option.internalValue]"
      @click.stop="option.method"
    >
      <v-list-item-icon>
        <v-icon>{{ option.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content v-text="option.text" />
    </v-list-item>
  </v-list>
</template>

<script>
import icons from '@/mixins/icons';
import { AssetMenu, GetterType } from '@/config/constants';
import * as moment from 'moment';
import AuthorizationService from '@/services/AuthorizationService';

export default {
  name: 'AssetHeaderMenuOptions',
  components: {},
  mixins: [icons],
  props: {
    willDelete: Boolean,
    isGoldSlide: Boolean,
    slide: Object,
    archive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: {}
    };
  },
  computed: {
    menu() {
      return [
        {
          disabled: false,
          internalValue: 'pdf',
          text: 'PDF',
          icon: this.icons.asPdf,
          method: this.asPdf
        },
        {
          disabled: false,
          internalValue: 'archive',
          text: this.archive ? 'Unarchive' : 'Archive',
          icon: this.archive ? this.icons.archive.fromArchive : this.icons.archive.toArchive,
          method: this.toggleArchived
        },
        {
          disabled: false,
          internalValue: 'deletion',
          text: this.willDelete ? 'Restore' : 'Delete',
          icon: this.willDelete ? this.icons.trash.fromTrash : this.icons.trash.toTrash,
          method: this.toggleSlideDeletion
        },
        {
          disabled: false,
          internalValue: 'goldSlide',
          text: this.isGoldSlide ? 'Normal Slide' : 'As Gold Slide',
          icon: this.isGoldSlide ? this.icons.stars.normal : this.icons.stars.outlined,
          method: this.toggleGoldSlide
        },
        {
          disabled: false,
          internalValue: 'inddDownload',
          text: 'Download Asset',
          icon: this.icons.downloadAsset,
          method: this.downloadInd
        }
      ];
    }
  },
  methods: {
    asPdf() {
      this.isLoading['pdf'] = true;
      const { ExportService } = require('@/services/modules/export');
      return new ExportService()
        .asPdf(this.slide._id, GetterType.group)
        .then(link => {
          this.$ga.event('behavior', 'click', 'download_pdf_sdp', this.slide._id);

          link.setAttribute(
            'download',
            `${moment().format('YYYYMMDD')}-${this.$store.state.product.selected.product.name}-${
              this.$store.state.product.selected.country
            }-${this.slide.name.trim()}_${this.slide.externalId}.pdf`
          );
          //document.body.appendChild(link);
          link.click();
          this.isLoading['pdf'] = false;
        })
        .catch(err => {
          this.isLoading['pdf'] = false;
        });
    },
    async downloadInd() {
      const slide = this.slide;
      const { ExportService } = require('@/services/modules/export');
      await new ExportService().downloadInddForGroup(slide._id, this.$store.state.auth.token, {
        country: this.$store.state.product.selected.country,
        product: this.$store.state.product.selected.product,
        customer: this.$store.state.user.me.customer
      });
    },
    deblockSlide(slide) {
      this.isLoading = true;
      return this.$store
        .dispatch('slides/updateActiveSlide', {
          ...slide,
          ...{ downloaded: { bool: false } },
          status: 'backlog'
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    toggleGoldSlide() {
      this.slide.goldSlide = !this.slide.goldSlide;
      this.updateActiveSlide('goldSlide');
      this.$emit('update');
    },
    updateName() {
      this.slide.name = this.$refs.name.textContent;
      this.updateActiveSlide('name');
    },
    async updateActiveSlide(entity) {
      return await this.$store.dispatch('slides/updateActiveSlide', {
        [entity]: this.slide[entity]
      });
    },
    copyExternalId() {
      this.$clipboard(this.slide.externalId);
    },
    copyUrl() {
      this.$clipboard(window.location.href);
    },
    isCreator() {
      return new AuthorizationService().isCreator();
    },
    isAdmin() {
      return new AuthorizationService().isAdmin();
    },
    async toggleArchived() {
      try {
        if (this.archive) {
          await this.$store.dispatch('slides/unarchiveActiveSlide');
        } else {
          await this.$store.dispatch('slides/archiveActiveSlide');
        }
        this.$emit('update');
      } catch (error) {
        this.$store.dispatch('alerts/warning', 'Not able to update slide.');
      }
    },
    async toggleSlideDeletion() {
      await this.$store.dispatch('slides/updateActiveSlide', {
        deletion: {
          willDelete: !this.slide.deletion.willDelete,
          willDeletedAfter: moment()
            .add(1, 'day')
            .toDate(),
          deletedBy: {
            email: this.$store.state.user.me.email,
            name: this.$store.state.user.me.name
          }
        }
      });
      this.$emit('update');
    },
    deleteSlide(thing) {
      if (this.slide.deletion.willDelete === false) {
        confirm(`Delete ${thing}`, `Are you sure you want to delete ${thing}?`, 'Yes', 'No').then(
          async yes => {
            if (yes) {
              this.toggleSlideDeletion();
            }
          }
        );
      } else {
        this.toggleSlideDeletion();
      }
    }
  }
};
</script>

<style></style>
